import { BaseModel } from "../base-model";
import { IItemStateModel } from "../base-itemstate";

export interface IPropertyVideoModel extends IItemStateModel {
    Id?: number;
    ObjectId?: number;
    VideoId?: number;
    Type?: number;
    Order?: number;
    Title?: string;
    Description?: string;
    FileName?: string;
    VideoUid?: string;
    VideoUrl?: string;
    OrignalVideoUrl?: string;
    CloudStreamVideoUid?: string;
    CloudStreamVideoUrl?: string;
    CloudStreamVideoThumbnailUrl?: string;
    Thumbnail?: string;
    Configuration?: any;
    ModifiedDate?: string;
}

export class PropertyVideoModel extends BaseModel<IPropertyVideoModel> implements IPropertyVideoModel {
    constructor(option?: IPropertyVideoModel) {
        super(option);
    }
}
